import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface MspState {
  loading: boolean;
  error: string | null;
  notification: {
    message: string;
    type: "success" | "error" | "info" | "warning";
  } | null;
}

const initialState: MspState = {
  loading: false,
  error: null,
  notification: null,
};

const mspSlice = createSlice({
  name: "msp",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setNotification: (
      state,
      action: PayloadAction<MspState["notification"]>
    ) => {
      state.notification = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearNotification: (state) => {
      state.notification = null;
    },
  },
});

export const {
  setLoading,
  setError,
  setNotification,
  clearError,
  clearNotification,
} = mspSlice.actions;
export default mspSlice.reducer;
